import { UnderConstruction } from '@@common';

type DomainReadModelViewProps = {
	contextId: string;
};

export default function DomainReadModelView({ contextId }: DomainReadModelViewProps) {
	return (
		<UnderConstruction
			featureName="Read Models"
			message="This feature is coming soon. You'll be able to define and manage read models for your domain context here."
		/>
	);
}
